"use client";

import { ScanText, Sparkles, SwatchBook, Upload } from "lucide-react";
import dynamic from "next/dynamic";
import { ShowcaseTabs, type ShowcaseTab } from "./showcase-tabs";

function WindowPlaceholder() {
  return (
    <div className="mx-auto h-[640px] w-full max-w-[1040px] rounded-t-xl border border-b-0 border-neutral-200 bg-white" />
  );
}

const PreUploadWindow = dynamic(
  () => import("./pre-editor-window").then((m) => m.PreUploadWindow),
  { ssr: false, loading: WindowPlaceholder },
);

const PreEditorWindow = dynamic(
  () => import("./pre-editor-window").then((m) => m.PreEditorWindow),
  { ssr: false, loading: WindowPlaceholder },
);

function pipelineTabs(moduleCount: number): ShowcaseTab[] {
  return [
    {
      value: "upload",
      icon: <Upload />,
      title: "Upload",
      text: "Drop in a PowerPoint or PDF, up to 50 MB. Uploading costs no credits.",
      content: <PreUploadWindow />,
    },
    {
      value: "extraction",
      icon: <ScanText />,
      title: "Extraction",
      text: "PPTX is rendered slide by slide, PDFs are read page by page. Slides that didn't read cleanly get a warning.",
      content: <PreEditorWindow step="extraction" />,
    },
    {
      value: "modules",
      icon: <Sparkles />,
      title: "Modules",
      text: `Up to three modules per slide from ${moduleCount} types, plus an intro, contents, key takeaways and an FAQ.`,
      content: <PreEditorWindow step="modules" />,
    },
    {
      value: "palette",
      icon: <SwatchBook />,
      title: "Palette",
      text: "Colors come from your slides. Pick a base and a scheme for five colors, in light and dark.",
      content: <PreEditorWindow step="palette" />,
    },
  ];
}

export function PipelineShowcase({ moduleCount }: { moduleCount: number }) {
  return <ShowcaseTabs tabs={pipelineTabs(moduleCount)} />;
}
